export class SkillConstants {
   public static readonly OVERALL_SKILL_ID = 0;
   public static readonly OPEN_REQUEUE_DIALOG = 0;
   public static readonly UNKNOWN_SKILL_NAME = 'Unknown Skill';
   public static readonly SKILL_TREEVIEW_NAME = 'TreeView';
   public static readonly MAX_PROGRESSION = 100;
}
